import {
  BaseballEventDetailId,
  BaseballEventDetailIdHalfValues,
  BaseballEventStatusId,
  BaseballIncidentId,
} from '@collector/sportsapi-client-legacy'

import {
  EventRelatedStatusConfig,
  EventRelatedStatuses,
  EventRelatedStatusValue,
  FINISHED_AFTER_EXTRA_INNING_DESCRIPTION,
  FINISHED_DESCRIPTION,
} from '../../../configuration'
import { inningsConfig, otherStatusIncidents } from './consts'
import { InningConfig } from './types'

export function getInningStatusConfig(
  config: InningConfig,
): EventRelatedStatusConfig<BaseballEventStatusId, BaseballIncidentId> {
  const {
    canFinishRegularTimeInNext,
    canFinishRegularTimeInOther,
    canFinishAfterExtraInning,
    canFinishAfterExtraInningInOther,
    breakAfterInning,
    inningStatus,
  } = config

  const possibleNextStatusIncidents: EventRelatedStatusValue<BaseballIncidentId>[] =
    []

  if (canFinishRegularTimeInNext) {
    possibleNextStatusIncidents.push({
      incidentId: BaseballIncidentId.FinishedRegularTime,
      description: FINISHED_DESCRIPTION,
    })
  }
  if (canFinishAfterExtraInning) {
    possibleNextStatusIncidents.push({
      incidentId: BaseballIncidentId.FinishedAfterExtraInning,
      description: FINISHED_AFTER_EXTRA_INNING_DESCRIPTION,
    })
  }
  if (breakAfterInning) {
    possibleNextStatusIncidents.push({
      incidentId: breakAfterInning,
      blockingStrategy: {
        unblockInstructions:
          "Break after inning is possible only on Half 'bottom'",
        isBlocked: ({ getEventDetailValue }) => {
          if (getEventDetailValue) {
            const eventDetailHalfValue = getEventDetailValue(
              BaseballEventDetailId.Half,
            ) as BaseballEventDetailIdHalfValues

            return eventDetailHalfValue === 'top'
          }

          throw new Error('getEventDetailValue not provided')
        },
      },
    })
  }

  const additionalOtherIncidents: EventRelatedStatusValue<BaseballIncidentId>[] =
    []

  if (canFinishRegularTimeInOther) {
    additionalOtherIncidents.push({
      incidentId: BaseballIncidentId.FinishedRegularTime,
      description: FINISHED_DESCRIPTION,
    })
  }

  if (canFinishAfterExtraInningInOther) {
    additionalOtherIncidents.push({
      incidentId: BaseballIncidentId.FinishedAfterExtraInning,
      description: FINISHED_AFTER_EXTRA_INNING_DESCRIPTION,
    })
  }

  const inningOtherStatus = [
    otherStatusIncidents[0],
    ...additionalOtherIncidents,
    ...otherStatusIncidents.slice(1),
  ]

  return {
    [inningStatus]: {
      possibleNextStatusIncidents,
      otherStatusIncidents: inningOtherStatus,
    },
  }
}

export function getBreakStatusConfig(
  config: InningConfig,
): EventRelatedStatusConfig<BaseballEventStatusId, BaseballIncidentId> {
  if (!config.nextInningStarted || !config.breakStatus) {
    return {}
  }

  const value: EventRelatedStatuses<BaseballIncidentId> = {
    possibleNextStatusIncidents: [config.nextInningStarted],
    otherStatusIncidents,
  }

  return {
    [config.breakStatus]: value,
  }
}

export function getInningsConfig(): EventRelatedStatusConfig<
  BaseballEventStatusId,
  BaseballIncidentId
> {
  return inningsConfig.reduce((acc, config) => {
    Object.assign(
      acc,
      getInningStatusConfig(config),
      getBreakStatusConfig(config),
    )
    return acc
  }, {})
}
